import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { isValidJSON } from '../lib';

export default function JSONModal({ id, title, initialValue, onSave, label = 'JSON', textareaRows = 20 }) {
  const [jsonValue, setJsonValue] = useState(JSON.stringify(initialValue, null, 2));

  useEffect(() => {
    setJsonValue(JSON.stringify(initialValue, null, 2));
  }, [initialValue]);

  const handleChange = (event) => setJsonValue(event.target.value);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonValue);
      toast('Copied to clipboard!', { type: 'notice', duration: 3000 });
    } catch (e) {
      toast.error('Failed to copy.');
    }
  };

  const handleSave = () => {
    try {
      const parsed = JSON.parse(jsonValue);
      onSave(parsed);
      toast.success(`${label} updated from JSON!`);
    } catch (e) {
      toast.error(`Error updating ${label}. Please ensure the content is valid JSON.`);
    }
  };

  const isJsonValid = isValidJSON(jsonValue);

  return (
    <div className="modal modal-xl fade" id={id} tabIndex={-1} aria-labelledby={`${id}-label`} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id={`${id}-label`}>
              {title}
            </h1>
            <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" aria-label="Close">
              <i className="fe fe-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="h-100 w-100 d-flex flex-column align-items-end">
              <button type="button" className="btn btn-primary btn-sm mb-2" onClick={handleCopy}>
                Copy <i className="fe fe-clipboard" />
              </button>
              <textarea id={`json-modal-${id}-text-area`} className="form-control" rows={textareaRows} onChange={handleChange} value={jsonValue} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSave} disabled={!isJsonValid} data-bs-dismiss="modal">
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
